import React from 'react';
import { Tooltip, Typography, Button, CircularProgress, TextField, Badge } from '@mui/material';
import { FilterSVG, SearchSVG, RefreshSVG } from '../svg';
import '../../styles/sass/global/components/filters.scss';
import { useTranslation } from 'react-i18next';
import { ButtonIcon } from '../ButtonIcon';
import { palette } from '../../styles/theme';

export const FiltersSection = ({
    searchText,
    handleChangeSearchText,
    applyFilter,
    toggleFiltersDialog,
    UIProps,
    disableButton,
    reset,
    placeholder = 'filter.searchPlaceholder',
    searchType = 'text',
    canFilter = true,
    filtersCount,
    extraActions,
}) => {
    const { t } = useTranslation();
    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            event.preventDefault();
            applyFilter();
        }
    };

    const handleSearchTextValue = (value) => {
        const regex = /^[0-9]*$/;
        if (searchType === 'number' && !regex.test(value)) {
            return;
        }
        handleChangeSearchText(value);
        if (value === '' && searchText !== '') {
            applyFilter('');
        }
    };

    const FiltersButton = (
        <Button className="button_custom mb-0" onClick={toggleFiltersDialog} disabled={UIProps.isLoading}>
            {UIProps.isLoading ? (
                <CircularProgress size={24} style={{ color: palette.secondary.main }} />
            ) : (
                <>
                    <FilterSVG className="mr-1" />
                    <span style={{ verticalAlign: 'middle' }}>{t('filter.title')}</span>
                </>
            )}
        </Button>
    );

    return (
        <div className="row">
            <div className="formStyle col mt-1">
                <form onSubmit={applyFilter}>
                    <TextField
                        className="textFieldStyle"
                        placeholder={t(placeholder)}
                        value={searchText}
                        onChange={e => handleSearchTextValue(e.target.value)}
                        variant="outlined"
                        InputProps={{
                            style: {
                                padding: '6px 16px',
                                height: '35px',
                            },
                            sx: {
                                color: palette.disabled[950],
                                '&::placeholder': { color: palette.disabled.main, opacity: 1 },
                                '& input::placeholder': { color: palette.disabled.main, opacity: 1 },
                            },
                            startAdornment: <SearchSVG className="mr-2" fill={palette.primary[700]} />,
                        }}
                        inputProps={{ style: { color: palette.disabled[950] } }}
                        FormHelperTextProps={{ sx: { color: palette.disabled.main } }}
                        onKeyDown={handleKeyDown}
                    />
                    <Button
                        className="button_custom--search mb-0 mr-3 ml-3"
                        onClick={applyFilter}
                        disabled={UIProps.isLoading || disableButton}
                        sx={{ backgroundColor: disableButton ? palette.disabled[500] : palette.primary.main }}
                    >
                        {UIProps.isLoading ? <CircularProgress size={24} style={{ color: 'white' }} /> : t('filter.search')}
                    </Button>
                    {reset && (
                        <ButtonIcon
                            className='mr-0 mb-0'
                            title={t('buttons.reset')}
                            icon={(<RefreshSVG style={{ width: '24px', heigth: '24px' }}/>)}
                            onClick={reset}
                        />
                    )}
                </form>
            </div>

            {canFilter && (
                <div className="col-auto" style={{ display: 'flex', alignItems: 'center' }}>
                    {UIProps.isLoading
                        ? FiltersButton
                        : (
                            <>
                                {extraActions}
                                <Tooltip title={<Typography color={palette.disabled[100]} fontSize={16}>{t('filter.title')}</Typography>}>
                                    <span>
                                        {filtersCount > 0 ? (
                                            <Badge
                                                badgeContent={filtersCount}
                                                color="secondary"
                                                overlap="circular"
                                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                sx={{
                                                    '& .MuiBadge-badge': {
                                                        transform: 'scale(1) translate(25%, -50%)',
                                                        color: palette.white
                                                    }
                                                }}
                                            >
                                                {FiltersButton}
                                            </Badge>
                                        ) : (
                                            FiltersButton
                                        )}
                                    </span>
                                </Tooltip>
                            </>
                        )
                    }
                </div>
            )}
        </div>
    );
};
